import * as apiGetMediaspaceAds from '@/api/mediaspace/getMediaspaceAds';
import * as apiUpdateMediaspaceAd from '@/api/mediaspace/updateMediaspaceAd';
import * as apiCreateMediaspaceAd from '@/api/mediaspace/createMediaspaceAd';
import * as apiDeleteMediaspaceAd from '@/api/mediaspace/deleteMediaspaceAd';
import * as apiReorderMediaspaceAds from '@/api/mediaspace/reorderMediaspaceAds';
import * as apiGetMediaspaceAdStatistics from '@/api/mediaspace/getMediaspaceAdStatistics';

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        mediaspaceAdListItems: [],
        statistics: [],
        statisticsLoading: false,
    }),
    mutations: {
        isLoading(state, loading) {
            state.loading = loading;
        },
        gotMediaspaceAds(state, ads) {
            state.mediaspaceAdListItems = ads
        },
        setStatisticsLoading(state, loading) {
            state.statisticsLoading = loading;
        },
        gotStatistics(state, statistics) {
            state.statistics = statistics;
        },
    },
    actions: {
        async getMediaspaceAdListItems({ commit }) {
            commit('isLoading', true);

            const result = await apiGetMediaspaceAds.get();
            if (result) {
                commit('gotMediaspaceAds', result)
            }
            commit('isLoading', false);
        },

        async ensureMediaspaceAdListItems({ commit, dispatch, getters }) {
            commit('isLoading', true)

            if (getters.mediaspaceAdListItems?.length === 0) {
                await dispatch('getMediaspaceAdListItems')
            } 
            commit('isLoading', false)
        },

        async create({ commit }, newAd) {
            commit('isLoading', true)

            await apiCreateMediaspaceAd.post(newAd);

            commit('isLoading', false)
        },

        async update({ commit }, ad) {
            commit('isLoading', true)

            await apiUpdateMediaspaceAd.put(ad.id, ad);

            commit('isLoading', false)
        },

        async delete({ commit }, id) {
            commit('isLoading', true)

            await apiDeleteMediaspaceAd.del(id);

            commit('isLoading', false)
        },

        async reorder({ commit }, reorderData) {
            commit('isLoading', true)

            await apiReorderMediaspaceAds.put(reorderData);

            commit('isLoading', false)
        },

        async getStatistics({ commit }) {
            commit('setStatisticsLoading', true);

            const result = await apiGetMediaspaceAdStatistics.get();
            if (result) {
                commit('gotStatistics', result);
            }
            commit('setStatisticsLoading', false);
        },
    },
    getters: {
        mediaspaceAdListItems: (state) => state.mediaspaceAdListItems,
        statistics: (state) => state.statistics,
        statisticsLoading: (state) => state.statisticsLoading
    }
} 